import { gql } from '@apollo/client';

export const GET_VIEW_UNMATCHED_TRACKS_ONLY = gql`
    query getViewUnmatchedTracksOnly {
        uiState @client {
            tracks {
                viewUnmatchedTracksOnly
            }
        }
    }
`;
